/* ------------------ */
/* REVEAL SYSTEM */
/* EXAMPLE
data-anim="fade-up/left/right/down/zoom/blur"
data-delay="200"
data-duration="1200"
data-repeat="true"
data-once="false" --> default == true
/* ------------------ */

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const el = entry.target;

    const delay = parseInt(el.dataset.delay || 0);
    const isRepeat = el.dataset.repeat === "true";
    const isOnce = el.dataset.once !== "false"; // default true

    if (entry.isIntersecting) {

      if (isOnce && el.classList.contains('in-view')) return;

      setTimeout(() => {
        el.classList.add('in-view');
      }, delay);

      if (isOnce && !isRepeat) {
        observer.unobserve(el);
      }

    } else {
      if (isRepeat) {
        el.classList.remove('in-view');
      }
    }
  });
}, {
  threshold: 0.2,
  rootMargin: "0px 0px -10% 0px"
});

/* DURATION:
data-duration="400"
*/
document.querySelectorAll('[data-anim]').forEach(el => {
  const duration = el.dataset.duration || 1000;

  el.style.setProperty('--duration', duration + 'ms');

  observer.observe(el);
});

/* ------------------ */
/* STAGGER SETUP - animation multiple elements with delay*/
/* EXAMPLE
PARENT:
data-stagger="120"
CHILDREN:
data-anim="fade-up"

NESTED:
<div data-stagger="200">
  <div data-anim="fade-up"></div>

  <div data-stagger="100">
    <div data-anim="fade-up"></div>
    <div data-anim="fade-up"></div>
  </div>
</div>
------------------ */

document.querySelectorAll('[data-stagger]').forEach(parent => {
  const stagger = parent.dataset.stagger || 120;

  parent.querySelectorAll('[data-anim]').forEach((el, i) => {
    // stagger delay
    el.style.setProperty('--i', i);
    el.style.setProperty('--stagger', stagger + 'ms');

    // ONLY apply default duration if element doesn't define one
    if (!el.dataset.duration) {
      el.style.setProperty('--duration', '1200ms');
    } else {
      el.style.setProperty('--duration', el.dataset.duration + 'ms');
    }
  });
});


/* ------------------ */
/* PARALLAX SYSTEM
Example: 
data-parallax
data-speed="0.3"
<div data-parallax data-speed="0.5" data-range="200"></div>
<div data-parallax data-speed="0.3" data-range="80"></div>
------------------ */

const parallaxEls = document.querySelectorAll('[data-parallax]');
let ticking = false;

function updateParallax() {
  if (!parallaxEls.length) {
    ticking = false;
    return;
  }

  const vh = window.innerHeight;
  const updates = [];

  parallaxEls.forEach(el => {
    if (el._visible === false) return;

    const rect = el.getBoundingClientRect();
    const speed = parseFloat(el.dataset.speed || 0.3);
    const range = parseFloat(el.dataset.range || 120);
    const progress = (vh - rect.top) / (vh + rect.height);
    const clamped = Math.max(0, Math.min(1, progress));

    updates.push({
      el,
      y: (clamped - 0.5) * range * speed,
    });
  });

  updates.forEach(({ el, y }) => {
    el.style.transform = `translateY(${y}px)`;
  });

  ticking = false;
}

function requestTick() {
  if (!ticking) {
    requestAnimationFrame(updateParallax);
    ticking = true;
  }
}

window.addEventListener('scroll', requestTick);
window.addEventListener('resize', requestTick);


/* ------------------ */
/* PARALLAX VISIBILITY OPTIMIZATION */
/* ------------------ */

const parallaxObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    entry.target._visible = entry.isIntersecting;
  });
});

parallaxEls.forEach(el => {
  el._visible = false;
  parallaxObserver.observe(el);
});
